import { Navigate, useLocation, useParams } from 'react-router'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath'

export const InboxPageV1Redirect = () => {
  const { pathname } = useLocation()
  const { id } = useParams()
  const to = `/${InboxesPath.root}/${id}/${pathname.split('/').pop()}`

  return <Navigate to={to} replace />
}
